// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import * as echarts from "echarts";
import "./assets/iconfont/iconfont.css";
import axios from "axios";
import router from "./router/index.js";
import store from "./store/index.js";
import global from "./global/index";
import moment from "moment"; // 导入文件
import Vuex from "vuex";
import isMobile from "./utils/isMobile";
import horizontalScroll from "el-table-horizontal-scroll";

Vue.prototype.$isMobile = isMobile;
// 注册全局 moment
Vue.prototype.$moment = moment;
Vue.prototype.$global = global;
Vue.prototype.$echarts = echarts;
Vue.prototype.$axios = axios; //将axios绑定到vue的原型上
Vue.config.productionTip = false;

Vue.use(Vuex);
Vue.use(horizontalScroll);
ElementUI.Select.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return !(this.filterable || this.multiple || !isIE) && !this.visible;
};

Vue.use(ElementUI);

/* 路由发生变化修改页面title */
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

// new Vue({
//   router,
//   el: '#app',
//   components: { App },
//   template: '<App/>'
// })



// WEBPACK FOOTER //
// ./src/main.js